import React from "react";

function UniversityIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M8.74 9.033c-.224.088-.481.133-.74.133-.26 0-.516-.044-.762-.132L3.784 7.797l-.352 3.4c0 .984 2.024 1.779 4.568 1.779 2.5 0 4.568-.795 4.568-1.778l-.352-3.403L8.74 9.033zm6.471-4.227l-6.726-2.41a1.496 1.496 0 00-1.01 0L.769 4.807a.584.584 0 00-.382.55c0 .248.153.468.382.55l1.428.512a3.293 3.293 0 00-.584 1.285.75.75 0 00-.18 1.281L.84 12.532a.381.381 0 00.375.444h1.385a.38.38 0 00.376-.444l-.59-3.547a.782.782 0 00.283-.58.749.749 0 00-.302-.593c.1-.423.306-.806.593-1.12l4.535 1.624c.326.117.683.117 1.01 0l6.725-2.41a.583.583 0 00-.02-1.1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default React.memo(UniversityIcon);
